(function(){
  'use strict';
  function initGallery(g){
    if(!g || g.dataset.aizelGalleryFix==='1') return;
    g.dataset.aizelGalleryFix='1';
    var main=g.querySelector('.product-gallery__main'), img=main&&main.querySelector('img');
    var ths=[].slice.call(g.querySelectorAll('[data-gallery-thumb]'));
    if(!img) return;
    ths.forEach(function(t){
      t.addEventListener('click',function(e){
        e.preventDefault();
        var u=t.getAttribute('data-full')||t.src;
        if(u) img.src=u;
        ths.forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
      });
    });
  }
  function init(){ document.querySelectorAll('[data-gallery]').forEach(initGallery); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();